import { render } from "./ProductCenter.vue?vue&type=template&id=34c904f7&scoped=true"
import script from "./ProductCenter.vue?vue&type=script&lang=js"
export * from "./ProductCenter.vue?vue&type=script&lang=js"

import "./ProductCenter.vue?vue&type=style&index=0&id=34c904f7&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-34c904f7"]])

export default __exports__